// 3rd party
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivityVerifyComponent } from './activity-verify/activity-verify.component';
import { LabelDataComponent } from './shared/component/label-data/label-data.component';
import { ActivityVerifyService } from './shared/service/activity-verify.service';

// services

@NgModule({
    imports:[
        CommonModule,
    ],
    exports:[
        ActivityVerifyComponent,
    ],
    declarations:[
        ActivityVerifyComponent,
        LabelDataComponent,
    ],
    providers:[
        ActivityVerifyService
    ]
})

export class VerifyModule {}


// WEBPACK FOOTER //
// ./src/app/verify/verify.module.ts